import { render, staticRenderFns } from "./ActividadesDetalleGrid.vue?vue&type=template&id=2f7e7f1d&scoped=true&"
import script from "./ActividadesDetalleGrid.vue?vue&type=script&lang=ts&"
export * from "./ActividadesDetalleGrid.vue?vue&type=script&lang=ts&"
import style0 from "./ActividadesDetalleGrid.vue?vue&type=style&index=0&id=2f7e7f1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7e7f1d",
  null
  
)

export default component.exports